<template>
  <div class="page-wrap">
    <van-nav-bar
      title="在线问师傅"
      left-text="返回"
      z-index="999"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    >
      <template #right>
        <van-button icon="question" size="small" plain @click="onClickRight">
          提问
        </van-button>
      </template>
    </van-nav-bar>
    <router-view></router-view>
    <!-- 浮动工具 -->
    <sx-tools :show="toolShow" v-if="toolShow" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sxTools from '../components/sx-tools'
export default {
  components: {
    sxTools
    //askForm,
    //dashiBox
  },
  data() {
    return {
      keyword: '',
      toolShow: false
    }
  },
  computed: {
    ...mapState(['dsShow', 'askShow', 'gridState'])
  },
  mounted() {
    this.toolShow = true
  },
  methods: {
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.replace('/')
      } else {
        this.$router.back()
      }
    },
    onClickRight() {
      this.$store.commit('setAskShow', true)
      console.log('提问题')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-box {
  position: relative;
}
</style>